import { header } from 'api/Auth/auth';
import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { IDUserApi, IDUserListApi, UpdateAccountApiResponse, UpdateAccountRqData, UserChangeLevelRqData, UserChangeStatusRqData } from 'models/DCK/DCKApiTypes';

class UserApi {
    async updateUser(rqData: UpdateAccountRqData, token: string): Promise<UpdateAccountApiResponse> {
        try {
            const response = await axios.put(apiPaths.updateUserInfo, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async userChangeStatus(rqData: UserChangeStatusRqData, token: string): Promise<UpdateAccountApiResponse> {
        try {
            const response = await axios.put(apiPaths.userChangeStatus, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async userChangeLevel(rqData: UserChangeLevelRqData, token: string): Promise<UpdateAccountApiResponse> {
        try {
            const response = await axios.put(apiPaths.changeUserLevel, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async deleteUser(id: string, token: string): Promise<IDUserListApi> {
        try {
            const response = await axios.delete(apiPaths.deleteUser + id, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async existUser(email: string): Promise<IDUserApi> {
        try {
            const response = await axios.get(apiPaths.existUser + email, {
                headers: header,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const userApi = new UserApi();
